
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1ANj0", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9NDUe = parcelRequire("9NDUe");

var $dhIhb = parcelRequire("dhIhb");


var $6vQ7t = parcelRequire("6vQ7t");


var $6qdyn = parcelRequire("6qdyn");


var $6tPi7 = parcelRequire("6tPi7");

// temp solution until a proper versioning
const $b37f69b9113097e2$export$93809551debf385f = '0.1.7';



var $2mIUd = parcelRequire("2mIUd");







class $0b34ee1818371cb7$export$faf4c91b80fc830e {
    push(event) {
        (0, $6qdyn.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $6tPi7.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $6tPi7.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $6tPi7.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $6tPi7.SUBSCRIBE_ALL]) this.subscribers[0, $6tPi7.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $6qdyn.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}











const $2ce62f5018c934fa$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $9NDUe.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};


const $b4d6b5abf11a05c7$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};






const $42d0c431223e47cd$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $42d0c431223e47cd$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $42d0c431223e47cd$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};


const $3040c7fea33f0940$export$b98e411ae80c806f = '/';


const $8fd2edf8eba823e1$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $8fd2edf8eba823e1$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $8fd2edf8eba823e1$var$SSR_PREFIX = 'ssr';
const $8fd2edf8eba823e1$var$mapKey = (key)=>{
    if (key === 'total') return $8fd2edf8eba823e1$var$SSR_PREFIX;
    return `${$8fd2edf8eba823e1$var$SSR_PREFIX}${0, $3040c7fea33f0940$export$b98e411ae80c806f}${key}`;
};
const $8fd2edf8eba823e1$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($8fd2edf8eba823e1$var$filterEntry(entry[1])) acc[$8fd2edf8eba823e1$var$mapKey(entry[0])] = $8fd2edf8eba823e1$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};


const $244f9919a9d9a05e$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $9NDUe.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $42d0c431223e47cd$export$6126f85083a72c6e)(data);
    const ssr = (0, $2ce62f5018c934fa$export$7167d96e9881d500)(data) ? (0, $8fd2edf8eba823e1$export$130f411261a599c5)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};


const $6075337381035fb6$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $6075337381035fb6$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $6075337381035fb6$export$9aa44f85591248d9() || {};
    return performance;
};
const $6075337381035fb6$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $6075337381035fb6$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};


const $11b8c398974d3d3a$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};



// @flow strict-local




const $617df705c7539c8f$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)(), PerformanceObserver1 = (0, $6075337381035fb6$export$74560fd4e61fd440)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($617df705c7539c8f$export$bea963256235a63e.observer) {
            (0, $6qdyn.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $617df705c7539c8f$export$bea963256235a63e.timings = resources.map((resource)=>$617df705c7539c8f$export$bea963256235a63e.transformResource(resource));
        $617df705c7539c8f$export$bea963256235a63e.observer = new PerformanceObserver1($617df705c7539c8f$export$bea963256235a63e.addTimings);
        $617df705c7539c8f$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($617df705c7539c8f$export$bea963256235a63e.observer) {
            $617df705c7539c8f$export$bea963256235a63e.observer.disconnect();
            $617df705c7539c8f$export$bea963256235a63e.observer = null;
        }
        $617df705c7539c8f$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$617df705c7539c8f$export$bea963256235a63e.transformResource(entry));
        const overflow = $617df705c7539c8f$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $617df705c7539c8f$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $617df705c7539c8f$export$bea963256235a63e.maxSize;
            $617df705c7539c8f$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $617df705c7539c8f$export$bea963256235a63e.timings.push(...entries);
    }
};
const $617df705c7539c8f$export$9eebb59359c2e9e5 = (startTime, performance = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)())=>{
    if (!PerformanceObserver || !$617df705c7539c8f$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $617df705c7539c8f$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};


const $a24c417f7cc7ffe3$var$cacheableTypes = [
    'script',
    'link'
];
const $a24c417f7cc7ffe3$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $a24c417f7cc7ffe3$var$CACHE_NETWORK = 'network';
const $a24c417f7cc7ffe3$var$CACHE_MEMORY = 'memory';
const $a24c417f7cc7ffe3$var$CACHE_DISK = 'disk';
const $a24c417f7cc7ffe3$var$calculateTransferType = (type, duration, size)=>{
    if (!$a24c417f7cc7ffe3$var$cacheableTypes.includes(type)) return $a24c417f7cc7ffe3$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $a24c417f7cc7ffe3$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $a24c417f7cc7ffe3$var$CACHE_DISK;
    if (size === undefined) return null;
    return $a24c417f7cc7ffe3$var$CACHE_NETWORK;
};
const $a24c417f7cc7ffe3$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$a24c417f7cc7ffe3$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $6075337381035fb6$export$9aa44f85591248d9)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $a24c417f7cc7ffe3$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $a24c417f7cc7ffe3$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $a24c417f7cc7ffe3$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $a24c417f7cc7ffe3$var$getNetworkData = (item, eventStart, hasTimingHeaders = $a24c417f7cc7ffe3$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$a24c417f7cc7ffe3$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($a24c417f7cc7ffe3$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $a24c417f7cc7ffe3$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$a24c417f7cc7ffe3$var$getSizeObject(transferSize)
        };
        if (transferType !== $a24c417f7cc7ffe3$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$a24c417f7cc7ffe3$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$a24c417f7cc7ffe3$var$getSizeObject(transferSize)
    };
};
const $a24c417f7cc7ffe3$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $617df705c7539c8f$export$9eebb59359c2e9e5)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $a24c417f7cc7ffe3$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $a24c417f7cc7ffe3$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$a24c417f7cc7ffe3$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};


const $5b5ccea2c9894fd1$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $5b5ccea2c9894fd1$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $5b5ccea2c9894fd1$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $5b5ccea2c9894fd1$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $9NDUe.ExperiencePerformanceTypes).PageLoad:
            case (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$5b5ccea2c9894fd1$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$5b5ccea2c9894fd1$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $9NDUe.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$5b5ccea2c9894fd1$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$5b5ccea2c9894fd1$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $9NDUe.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$5b5ccea2c9894fd1$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $5b5ccea2c9894fd1$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $6tPi7.FMP_MARK))?.time || (0, $2ce62f5018c934fa$export$7167d96e9881d500)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$5b5ccea2c9894fd1$var$LoadMetricKeys.tti]: Math.round(tti),
        [$5b5ccea2c9894fd1$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$5b5ccea2c9894fd1$var$getHistogram(data, performanceConfig)
    };
};
const $5b5ccea2c9894fd1$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $6tPi7.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$5b5ccea2c9894fd1$var$InlineResultMetricKeys.result]: Math.round(result),
        [$5b5ccea2c9894fd1$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$5b5ccea2c9894fd1$var$getHistogram(data, performanceConfig)
    };
};
const $5b5ccea2c9894fd1$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$5b5ccea2c9894fd1$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$5b5ccea2c9894fd1$var$getHistogram(data, performanceConfig)
    };
};
const $5b5ccea2c9894fd1$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $9NDUe.ExperiencePerformanceTypes).PageLoad:
        case (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad:
            return $5b5ccea2c9894fd1$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $9NDUe.ExperiencePerformanceTypes).InlineResult:
            return $5b5ccea2c9894fd1$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $9NDUe.ExperiencePerformanceTypes).Custom:
            return $5b5ccea2c9894fd1$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $5b5ccea2c9894fd1$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$5b5ccea2c9894fd1$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $a24c417f7cc7ffe3$export$81a7d52441a06b50)(data, resourceConfig),
        ...(0, $11b8c398974d3d3a$export$1a2bb347935fc536)(data, bundleEvalConfig),
        ...(0, $244f9919a9d9a05e$export$e952f50a4f2d02da)(data, ssr),
        ...(0, $2ce62f5018c934fa$export$7167d96e9881d500)(data) ? (0, $b4d6b5abf11a05c7$export$b88d990436be0f8a)() : null
    };
};





const $e43a228b93e1a488$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $6tPi7.PageVisibleState).HIDDEN : (0, $6tPi7.PageVisibleState).VISIBLE)
    };
};



const $8df188cba8fb2c00$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};


const $73d213c1c4a7569d$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};



var $uxMYQ = parcelRequire("uxMYQ");


var $2XqLN = parcelRequire("2XqLN");


const $394f0f05c63529b9$export$f435c2789ca334a7 = (0, $2XqLN.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($uxMYQ))).getParser((0, $6075337381035fb6$export$9aa44f85591248d9)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});





const $d31b101d9f76047a$export$db7649b8854107ad = (0, $2XqLN.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});


const $547d2343431f01a1$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};





const $692eaa404d1668b4$export$81efaf8414879a1a = (0, $2XqLN.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});


const $01baa2f68d381be2$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};


const $80aee942315af067$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};


const $dfde895fd6c5bf73$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};


const $9d53220ee841f227$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};




const $5944211c678f5c31$var$UNKNOWN_VALUE = 'unknown';
const $5944211c678f5c31$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $5944211c678f5c31$var$UNKNOWN_VALUE,
    id: $5944211c678f5c31$var$UNKNOWN_VALUE,
    uuid: $5944211c678f5c31$var$UNKNOWN_VALUE,
    state: {
        id: $5944211c678f5c31$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $9NDUe.ExperienceTypes).Experience,
    category: $5944211c678f5c31$var$UNKNOWN_VALUE,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $6tPi7.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $5944211c678f5c31$var$Publisher {
    publish(data) {
        const payloadStart = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $6qdyn.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$5944211c678f5c31$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $b37f69b9113097e2$export$93809551debf385f) || $5944211c678f5c31$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $394f0f05c63529b9$export$f435c2789ca334a7)(),
                    ...(0, $d31b101d9f76047a$export$db7649b8854107ad)(),
                    ...(0, $692eaa404d1668b4$export$81efaf8414879a1a)(),
                    ...(0, $01baa2f68d381be2$export$ce1cf816dce1da56)(),
                    ...(0, $8df188cba8fb2c00$export$e34e4529b979f74c)(this.app),
                    ...(0, $73d213c1c4a7569d$export$82ae485178b37419)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $2mIUd.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $e43a228b93e1a488$export$723b4c298aca63af)(supportedData),
                    ...(0, $2ce62f5018c934fa$export$7167d96e9881d500)(supportedData) && (0, $dfde895fd6c5bf73$export$a3dc8251cf55b2e0)(this.ssr),
                    ...(0, $2ce62f5018c934fa$export$7167d96e9881d500)(supportedData) && (0, $80aee942315af067$export$fdbea518c19dfa8)(this.ssr),
                    ...this.featureFlagClient && (0, $547d2343431f01a1$export$e62953d023125748)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $dh538.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: (0, $6075337381035fb6$export$8cd0c777b0eb66a0)()?.timeOrigin ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $6075337381035fb6$export$8cd0c777b0eb66a0)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $6qdyn.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $6vQ7t.getGlobalEventStream)() instanceof (0, $0b34ee1818371cb7$export$faf4c91b80fc830e))) {
            const eventStream = new (0, $0b34ee1818371cb7$export$faf4c91b80fc830e)();
            eventStream.push({
                type: (0, $6tPi7.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $6vQ7t.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $dhIhb.visibilityChangeObserver).start();
        (0, $617df705c7539c8f$export$bea963256235a63e).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $5b5ccea2c9894fd1$export$738d24377baf6a5e)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $5944211c678f5c31$var$UNKNOWN_VALUE;
        this.hostname = (0, $6075337381035fb6$export$9aa44f85591248d9)()?.location?.hostname || '';
        this.tenantType = (0, $2mIUd.TenantType).RealUser;
        this.app = {
            version: {
                web: $5944211c678f5c31$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $9d53220ee841f227$export$e7b0ac011bb776c6);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $5944211c678f5c31$export$edb879ae55bb9be3 = new $5944211c678f5c31$var$Publisher();
module.exports["payloadPublisher"] = $5944211c678f5c31$export$edb879ae55bb9be3;

});

parcelRegister("2mIUd", function(module, exports) {

var $c67c9e91b3aa2761$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});
module.exports["TenantType"] = $c67c9e91b3aa2761$export$92a757ac1398962f;

});


//# sourceMappingURL=initializeUFOPublisher.7010eb9b.js.map
